import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { Assignee } from 'src/app/api/assignee.service';
import { UiSafeStaff } from 'src/app/api/commonInterfaces';


class UserDropdownItem {
  constructor(public assignee: UiSafeStaff) {

  }

  get fullName() {
    return this.assignee.first + " " + (this.assignee.nickname ? `(${this.assignee.nickname}) ` : "") + this.assignee.last
  }

}

@Component({
    selector: 'app-user-dropdown',
    templateUrl: './user-dropdown.component.html',
    styleUrls: ['./user-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserDropdownComponent),
            multi: true
        }
    ],
    standalone: false
})
export class UserDropdownComponent implements OnInit, ControlValueAccessor {

  private _staff: UiSafeStaff[] = [];
  @Input() set staff(value: UiSafeStaff[]) {

    this._staff = [...value].sort((a, b) => a.first.localeCompare(b.first))
    this.dropdownItems = [new UserDropdownItem(this.unassignedUser), ...this._staff.map(a => new UserDropdownItem(a))]
    this.filteredDropdownItems = [...this.dropdownItems]
  }

  @Input() placeholder: string = "Select a User"

  private readonly unassignedUser: UiSafeStaff = {
    active: 1,
    email: "",
    phone1: "",
    apptURL: "",
    city: "",
    state: "",
    first: "Unassigned",
    middle: "",
    last: "",
    id: 0,
    nickname: "",
    roles: ['admin', 'atl', 'blog', 'conf', 'consultant', 'crisis', 'everyone', 'finance', 'ft', 'ftm', 'fund', 'head','hr', 'intern', 'it', 'ma', 'marketing', 'mc', 'ops', 'pt', 'sales', 'salesAdmin', 'super', 'tl', 'travel' ],
    title: "",
    driverNotes: "",
    reviewSupervisorId: 0,
    alwaysShowOnStaffing: 0,
    restricted: 0,
  }

  get staff(): UiSafeStaff[] {
    return this._staff;
  }

  dropdownItems: UserDropdownItem[] = []
  filteredDropdownItems: UserDropdownItem[] = []
  lastQuery: string = ""

  selectedUser: UserDropdownItem | undefined;

  private _readonly = false;
  @Input() set readonly(value: boolean) {
    this._readonly = value
  }

  get readonly() {
    return this._readonly
  }


  constructor() { }

  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;


  ngOnInit(): void {
  }

  search(event: any) {
    if (!event.query  ) {
      this.filteredDropdownItems = [...this.dropdownItems]
    }
    else {
      if (event.query.length < this.lastQuery.length) {
        this.filteredDropdownItems = [...this.dropdownItems]
      }

      this.filteredDropdownItems = this.filteredDropdownItems.filter(
        i => i.assignee.first.toLowerCase().includes(event.query.toLowerCase()) ||
          i.assignee.last.toLowerCase().includes(event.query.toLowerCase())
      )
    }

    this.lastQuery = event.query
  }

  getDisplayName(assignee: Assignee) {
    return assignee.firstName + " " + assignee.lastName;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {

    if (value) {
      this.selectedUser = this.dropdownItems.find(u => u.assignee.id.toString() === value)
    }
    else {
      this.selectedUser = undefined;
    }


  }

  onUserSelected(event: AutoCompleteSelectEvent) {
    if (this.selectedUser) {
      this.onChange(this.selectedUser.assignee.id)
    }
    else {
      this.onChange(null)
    }
  }

  onUserClear() {
    this.selectedUser = undefined
    this.onChange(null)

  }

}
